export class PrimedResponses
{
  private static entries = new Map<string, unknown>();

  public static set( key: string, value: unknown ): void
  {
    this.entries.set( key, value );
  }

  public static take<T>( key: string ): T | undefined
  {
    if ( !this.entries.has( key ) ) return undefined;
    const value = this.entries.get( key ) as T;
    this.entries.delete( key );
    return value;
  }

  public static size(): number
  {
    return this.entries.size;
  }

  public static clear(): void
  {
    this.entries.clear();
  }
}
